import script from "./virus-view.vue?vue&type=script&lang=ts&setup=true"
export * from "./virus-view.vue?vue&type=script&lang=ts&setup=true"

import "./virus-view.vue?vue&type=style&index=0&id=5411a7e0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5411a7e0"]])

export default __exports__